import { Context, type Effect, Layer, type Queue, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { RecordingFullscreenFailure, RecordingFullscreenObservation, RecordingFullscreenSnapshot } from "./fullscreen-model.ts";

export class RecordingFullscreenIo extends Context.Service<RecordingFullscreenIo, {
  readonly events: (admission: Scope.Scope) => Effect.Effect<Queue.Queue<RecordingFullscreenObservation>, RecordingFullscreenFailure, Scope.Scope>;
}>()("workerstation/frontend/RecordingFullscreenIo") {}
export const RecordingFullscreenIoTest = (io: typeof RecordingFullscreenIo.Service) => Layer.succeed(RecordingFullscreenIo, io);
export interface RecordingFullscreenSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<RecordingFullscreenSnapshot>>;
  readonly read: Effect.Effect<RecordingFullscreenSnapshot>;
}
export class RecordingFullscreenSessions extends Context.Service<RecordingFullscreenSessions, {
  readonly open: Effect.Effect<RecordingFullscreenSession, never, Scope.Scope>;
}>()("workerstation/frontend/RecordingFullscreenSessions") {}
